import AppDashboard from "../AppDashboard";
import { useParams } from "react-router-dom";

import useUser from "../../hooks/useUser";
import {useGetPayerPlansQuery} from "../../redux/services/payerPlanApi";
import ListPayerPlansScreen from "../../components/payer-plans/ListPayerPlansScreen";

const ListPayerPlansPage = props => {
  const user = useUser();
  const {patientId: patientIdParam} = useParams();
  const patientId = (
    user?.is_patient
    ? user?.patient?.id
    : patientIdParam
  );
  const paymentPlanQuery = useGetPayerPlansQuery({patient_id: patientId}, {skip: !patientId});
  const payerPlans = paymentPlanQuery?.data?.data || [];
  return (
    <AppDashboard 
      title='Insurance Plans' 
      isLoading={paymentPlanQuery.isLoading}
      showTitle
      showBackButton
    >
      <ListPayerPlansScreen
        patientId={patientId}
        payerPlans={payerPlans}
      />
    </AppDashboard>
  );
};

export default ListPayerPlansPage;